import { BrowserRouter, Route, Routes } from "react-router-dom";
import { NotFound } from "../modules/404";

import { DashboardLayout } from "../layouts/dashboard.layout";
// import { ProtectedRoute } from "./protected-route";

import { Codart } from "../modules/codarts/pages";

export const LoggedInRouter = () => {
  // const { data, loading, error } = useMe();

  // if (!data || loading || error) {
  //   return <Loading />;
  // }

  // if (data?.me?.role === UserRole.Admin) {
  //   return <AdminRouter />;
  // }
  // if (data?.me?.role === UserRole.Client) {
  //   return <ClientRouter />;
  // }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DashboardLayout />}>
          <Route>
            {/* //element={<ProtectedRoute roles={["Any"]} />} */}
            <Route path="/" element={<Codart />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
